var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loc-prod-detail-add-stash-wrapper"},[_c('add-to-stash-main',{attrs:{"productvariants":_vm.productvariants,"outofStockSubscribeVariants":_vm.outofStockSubscribeVariants,"product":_vm.productdetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }